import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';

import { AuthService } from './auth.service';

const RETRY_HEADER = 'X-Retried-After-Refresh';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      const alreadyRetried = req.headers.has(RETRY_HEADER);
      if (alreadyRetried || !(error instanceof HttpErrorResponse) || error.status !== 401) {
        return throwError(() => error);
      }

      return from(authService.ensureFreshToken()).pipe(
        switchMap(refreshed => {
          if (!refreshed) {
            authService.logoutSilently();
            return throwError(() => error);
          }

          const token = authService.getToken();
          const retryReq = req.clone({
            setHeaders: {
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
              [RETRY_HEADER]: 'true'
            }
          });

          return next(retryReq);
        })
      );
    })
  );
};
